<template>
  <div class="schools-dropdown">
    <PillDropdown
      :name="$t('search.schoolsDropdownName')"
      :allow-multi-select="true"
      :options="schoolsState"
      :show-search="true"
      :show-select-all="true"
      @clear-filters="clearFilters"
      @apply-filters="applyFilters"
    >
    </PillDropdown>
  </div>
</template>

<script setup>
import { useMainStore } from '../../../stores/mainStore.js';
import { useSearchFilters } from '../../../composables/useSearchFilters';
import PillDropdown from './PillDropdown.vue';
import { trackOrgFilterApplied } from '../../../helpers/searchAnalytics';

const emit = defineEmits(['applyFilters']);
const mainStore = useMainStore();
const { schoolsState, initializeSchools, selectedSchools } = useSearchFilters();

const searchOrgs = mainStore.settings?.searchOrgs || [];
const allOrgs = mainStore.organizations || [];

let searchableOrgs = [];
if (searchOrgs.length > 0) {
  searchableOrgs = allOrgs.filter((org) => searchOrgs.includes(org.id));
} else {
  searchableOrgs = allOrgs;
}

const formattedOrgs = searchableOrgs.map((school) => ({
  name: school.name,
  org_id: school.id,
  checked: !!mainStore.settings?.searchDefaultAllOrgs,
}));

initializeSchools(formattedOrgs);

function clearFilters() {
  emit('applyFilters', null);
}

function applyFilters() {
  if (selectedSchools.value.length > 0) {
    trackOrgFilterApplied(selectedSchools.value);
  }

  emit('applyFilters', selectedSchools.value);
}
</script>
